<template>
  <div>
    <v-container grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <StockBalance />
        </v-flex>
        <v-flex d-flex xs12 md8>
          <MissingSerialNumber />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import StockBalance from "../components/StockBalance";
import MissingSerialNumber from "../components/MissingSerialNumber";

export default {
  components: {
    StockBalance,
    MissingSerialNumber
  }
};
</script>

<style scoped></style>
